import { StyleSheet } from 'aphrodite';
import { Button } from '@HoudiniUI/Button';
import { ButtonGroup } from '@HoudiniUI/ButtonGroup';

interface SegmentedTabsProps<T extends string> {
	options: ReadonlyArray<{ value: T; label: string }>;
	value: T;
	onChange: (value: T) => void;
	size?: 'default' | 'sm';
	ariaLabel?: string;
}

export function SegmentedTabs<T extends string>({
	options,
	value,
	onChange,
	size = 'default',
	ariaLabel,
}: SegmentedTabsProps<T>) {
	return (
		<ButtonGroup aria-label={ariaLabel} styles={[styleSheet.group]}>
			{options.map(opt => (
				<Button
					key={opt.value}
					type='button'
					size={size === 'sm' ? 'sm' : 'default'}
					variant={opt.value === value ? 'primary' : 'outline'}
					aria-pressed={opt.value === value}
					onClick={() => onChange(opt.value)}
				>
					{opt.label}
				</Button>
			))}
		</ButtonGroup>
	);
}

const styleSheet = StyleSheet.create({
	group: {
		alignSelf: 'flex-start',
	},
});
